import { connect } from 'react-redux';
import featureEnabled from 'shared/helper/feature';
import svgLogoImage from 'rubriq/images/rubriq-logo-rgb-color-light-32x119.jpg';
import chinaPngLogoImage from '../images/localized/aje-current-logo-rgb-no-clear-space.png';
import filingIcon from '../images/localized/filing-icon.png';
import Footer from './Footer';
var mapStateToProps = function mapStateToProps(_ref) {
  var _ref$application = _ref.application,
    links = _ref$application.config.links,
    siteLanguage = _ref$application.siteLanguage;
  return {
    filingIcon: siteLanguage === 'cn' ? filingIcon : null,
    footerLinks: links.footer[siteLanguage] || links.footer.en,
    qrLinks: links.qr[siteLanguage] || links.qr.en,
    pngLogoImage: siteLanguage === 'cn' ? chinaPngLogoImage : null,
    socialMediaLinks: links.socialMedia[siteLanguage] || links.socialMedia.en,
    svgLogoImage: svgLogoImage,
    showCurieNav: featureEnabled('curie_is_launched')
  };
};
export default connect(mapStateToProps)(Footer);